// @flow
import {SVGIcon} from '@homeaway/react-svg';
import {CALENDAR__24, CLOSE__24} from '@homeaway/svg-defs';
import Tooltip from '@homeaway/react-tooltip';
import React, {PureComponent} from 'react';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import {DATE_MODAL} from '../../actions/modals';
import routerActions from '../../actions/router';

import type {Node} from 'react';

import './DatesPromptTooltip.less';

type State = {isOpen: boolean};

type StateProps = {
    openDateRangePicker: () => typeof routerActions.pushModal
};
type Props = StateProps & {
    dateRangePicker: Node,
    placement: 'top' | 'bottom',
    portalClassName: string
};

export class DatesPromptTooltip extends PureComponent<Props, State> {
    timer: TimeoutID;
    state: State = {isOpen: true};

    componentDidMount() {
        this.timer = setTimeout(this.closeTooltip, 8000);
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    closeTooltip = () => {
        this.setState({isOpen: false});
    };

    handleClickTooltip = () => {
        this.props.openDateRangePicker();
        this.closeTooltip();
    };

    render() {
        return (
            <Tooltip
                content={
                    <span className={'DatesPromptTooltip__content'}>
                        <button
                            className={
                                'DatesPromptTooltip__icon DatesPromptTooltip__button DatesPromptTooltip__icon--left'
                            }
                            onClick={this.handleClickTooltip}
                        >
                            <SVGIcon markup={CALENDAR__24} inline />
                        </button>

                        <button
                            className={
                                'DatesPromptTooltip__text DatesPromptTooltip__button micro'
                            }
                            onClick={this.handleClickTooltip}
                        >
                            <FormattedMessage
                                id="datesPromptText"
                                description="datesPrompt text"
                                defaultMessage="Add some trip dates"
                            >
                                {(message) => message}
                            </FormattedMessage>
                        </button>
                        <button
                            className={
                                'DatesPromptTooltip__button DatesPromptTooltip__closer DatesPromptTooltip__icon DatesPromptTooltip__icon--right'
                            }
                            onClick={this.closeTooltip}
                        >
                            <SVGIcon markup={CLOSE__24} inline />
                        </button>
                    </span>
                }
                interactiveContainer
                isOpen={this.state.isOpen}
                placement={this.props.placement}
                portalClassName={`DatesPromptTooltip ${
                    this.props.portalClassName
                }`}
                trigger="none"
                wrappingMethod={'block'}
            >
                {this.props.dateRangePicker}
            </Tooltip>
        );
    }
}

const mapDispatchToProps = {
    openDateRangePicker: () => routerActions.pushModal(DATE_MODAL)
};

export default connect(
    null,
    mapDispatchToProps
)(DatesPromptTooltip);
